import React, { ReactNode } from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import * as S from './styles';

const BackToListing = ({
  title,
  style,
  extra,
}: {
  title: string | ReactNode;
  style?: React.CSSProperties;
  extra?: React.ReactNode;
}) => {
  const { t } = useTranslation('general');
  const navigate = useNavigate();

  return (
    <S.Container style={style}>
      <S.LeftContent>
        <Button
          type="link"
          icon={<ArrowLeftOutlined style={{ fontSize: '1rem' }} />}
          className="back-to-listing-button"
          onClick={() => {
            navigate(-1);
          }}
        >
          {t('components.back-to-listing.description')}
        </Button>
        <span className="back-to-listing-divider">|</span>
        <span className="back-to-listing-title">{title}</span>
      </S.LeftContent>
      {extra}
    </S.Container>
  );
};

export default BackToListing;
